import { useEffect, useRef } from "react";

import { useAuthContext } from "../../../Context/AuthContext";
import { useCustomerContext } from "../../../Context/CustomerContext";
import { useCloudAnalyticsContext } from "../CloudAnalyticsContext";
import { useNewReportHandler } from "../report/hooks";

const ReportCreate = () => {
  const { defaultConfigLoading } = useCloudAnalyticsContext();
  const { customer, init: customerCtxInit } = useCustomerContext();
  const { currentUser } = useAuthContext({ mustHaveUser: true });
  const createReport = useNewReportHandler({
    baseUrl: `/customers/${customer.id}/analyze/reports`,
    mixpanelEventName: "analytics.reports.new",
    replaceCurrentRoute: true,
  });
  const isCreatingReport = useRef<boolean>(false);

  useEffect(() => {
    if (customerCtxInit && currentUser.email && !defaultConfigLoading && !isCreatingReport.current) {
      isCreatingReport.current = true;
      createReport();
    }
  }, [currentUser.email, customerCtxInit, defaultConfigLoading, createReport]);

  return <></>;
};

export default ReportCreate;
